

import { Logout, Settings } from '@mui/icons-material';
import { ListItemIcon, Menu, MenuItem } from '@mui/material';
import React from 'react'
import { useValue } from '../../context/ContextProvider'
import useCheckToken from '../../hooks/useCheckToken';
import Profile from './Profile';



const UserMenu = ({ anchorUserMenu, setAnchorUserMenu }) => {

    useCheckToken();    //Para verificar que el Token del usuario no haya expirado

    const { state: { currentUser }, dispatch } = useValue();
    const handleCloseUserMenu = () => {
        setAnchorUserMenu(null);
    }

    /* Funcion de solo Test, para probar el código de autorización.  Se debe borrar. */
    /*
    const testAutorization = async () => {
        const url = process.env.REACT_APP_SERVER_URL + '/room';
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    authorization: `Bearer ${currentUser.token}`
                }
            })
            const data = await response.json();
            if (!data.success) {
                if (response.status === 401) {
                    //Si la respuesta del servidor es usuario no autorizado (401), entonces se desloguea automáticamente al usuario
                    dispatch({ type: 'UPDATE_USER', payload: null });
                }
                throw new Error(data.message);
            }
            console.log({ data });
        } catch (error) {
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: error.message } });
            console.log(error);
        }
    }
    */

    return (
        <>
            <Menu
                anchorEl={anchorUserMenu}
                open={Boolean(anchorUserMenu)}
                onClick={handleCloseUserMenu}
                onClose={handleCloseUserMenu}
            >
                {(!currentUser.google) &&
                    <MenuItem
                        onClick={() => dispatch({ type: 'UPDATE_PROFILE', payload: { open: true, file: null, photoURL: currentUser?.photoURL } })}
                    >
                        <ListItemIcon>
                            <Settings fontSize='small' />
                        </ListItemIcon>
                        Perfil
                    </MenuItem>
                }
                <MenuItem
                    onClick={() => dispatch({ type: 'UPDATE_USER', payload: null })}
                >
                    <ListItemIcon>
                        <Logout fontSize='small' />
                    </ListItemIcon>
                    Logout
                </MenuItem>

            </Menu>
            <Profile />
        </>
    )
}

export default UserMenu